import { useAccount } from "@/context/account";
import { gql } from "@/gql";
import { useSubscription } from "@apollo/client/react";

const CONTRACT_STATUS = gql(`
  subscription ContractStatus($accountId: ID!) {
    contractStatusChanged(accountId: $accountId) {
      contract {
        ...PricedContract
      }
    }
  }
`);

export const useContractStatusSubscription = () => {
  const { account } = useAccount();

  return useSubscription(CONTRACT_STATUS, {
    variables: { accountId: account.id },
  });
};
